<template>
  <div>
    <Modal :title="title" v-model="createSubnetModal" width="1000" @on-cancel="formReset" :mask-closable="false">
      <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
      <div class="create-subnet-form">
        <Form ref="changeForm" :model="changeForm" style="padding-right: 10px" :rules="changeRule">
          <FormItem label="子网名称" prop="name">
            <Input v-model="changeForm.name" placeholder="请填写子网名称" :maxlength="128"/>
          </FormItem>
          <FormItem label="网络地址" prop="cidr">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>CIDR格式的网络地址（例如：192.168.0.0/24 或 2001:DB8::/48）</p>
              </div>
            </tooltip>
            <Input v-model="changeForm.cidr" placeholder="请填写网络地址" :disabled="!!changeForm.id"/>
          </FormItem>
          <FormItem label="IP版本" prop="ip_version" v-if="!changeForm.id">
            <Select v-model="changeForm.ip_version">
              <Option :value="4" :key="4">IPv4</Option>
              <Option :value="6" :key="6">IPv6</Option>
            </Select>
          </FormItem>
          <FormItem label="网关IP" prop="gateway_ip" v-if="!changeForm.disable_gateway">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>
                  <span>网关IP地址(例如 192.168.0.254) 缺省值是网络地址的第一个IP (例如 192.168.0.0/24的192.168.0.1, 2001:DB8::/48的2001:DB8::1).</span>
                  <span>如果您要使用缺省值，保留为空白。如果您不想使用网关，勾选下面的'禁用网关'。</span>
                </p>
              </div>
            </tooltip>
            <Input v-model="changeForm.gateway_ip"/>
          </FormItem>
          <FormItem label="禁用网关">
            <i-switch v-model="changeForm.disable_gateway">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="激活DHCP" prop="enable_dhcp">
            <i-switch v-model="changeForm.enable_dhcp">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="分配地址池" prop="allocation_pools">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>
                  <span>IP地址分配池. 每条记录是：开始IP,结束IP(例如 192.168.1.100,192.168.1.120) ，每行一条记录.</span>
                </p>
              </div>
            </tooltip>
            <Input v-model="changeForm.allocation_pools" type="textarea" :rows="4"/>
          </FormItem>
          <FormItem label="DNS服务器" prop="dns_nameservers">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>
                  <span>该子网的DNS服务器IP地址列表，每行一个。</span>
                </p>
              </div>
            </tooltip>
            <Input v-model="changeForm.dns_nameservers" type="textarea" :rows="4"/>
          </FormItem>
          <FormItem label="主机路由" prop="host_routes">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>
                  <span>主机增加额外的路由. 记录格式是：目的CIDR, 下一跳(例如192.168.200.0/24,10.56.1.254) ，每行一条记录。</span>
                </p>
              </div>
            </tooltip>
            <Input v-model="changeForm.host_routes" type="textarea" :rows="4"/>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
        <Button @click="createSubnetModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { changePrivateCloudSubnet, detailPrivateCloudSubnet } from '@/api/private-cloud/subnet'
export default {
  name: 'create-subnet',
  data () {
    return {
      createSubnetModal: false,
      changeLoading: false,
      title: '创建子网',
      errorMsg: '',
      errorMsgShow: false,
      changeForm: {
        id: '',
        network_id: '',
        name: '',
        ip_version: 4,
        cidr: '',
        gateway_ip: '',
        enable_dhcp: true,
        allocation_pools: '',
        dns_nameservers: '',
        host_routes: '',
        disable_gateway: false
      },
      changeRule: {
        name: [
          { required: true, message: '子网名称不能为空', trigger: 'blur' }
        ],
        cidr: [
          { required: true, message: '网络地址不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModal (networkId, name = '') {
      this.changeForm.network_id = networkId
      if (name) {
        this.title = '「' + name + '」创建子网'
      } else {
        this.title = '创建子网'
      }
      this.createSubnetModal = true
    },
    openModifyModal (id) {
      if (id) {
        detailPrivateCloudSubnet(id).then(res => {
          const result = res.data.subnet
          this.changeForm.id = result.id
          this.changeForm.network_id = result.network_id
          this.changeForm.name = result.name
          this.changeForm.ip_version = result.ip_version
          this.changeForm.cidr = result.cidr
          this.changeForm.gateway_ip = result.gateway_ip
          this.changeForm.enable_dhcp = result.enable_dhcp
          if (result.gateway_ip === null) {
            this.changeForm.disable_gateway = true
          }
          this.changeForm.dns_nameservers = result.dns_nameservers.join('\n')
          let hostRoutes = []
          for (let i in result.host_routes) {
            hostRoutes.push(result.host_routes[i].destination + ',' + result.host_routes[i].nexthop)
          }
          this.changeForm.host_routes = hostRoutes.join('\n')
          let allocationPools = []
          for (let i in result.allocation_pools) {
            allocationPools.push(result.allocation_pools[i].start + ',' + result.allocation_pools[i].end)
          }
          this.changeForm.allocation_pools = allocationPools.join('\n')
          this.title = '「' + result.name + '」编辑子网'
          this.createSubnetModal = true
        })
      }
    },
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          changePrivateCloudSubnet(this.changeForm, this.changeForm.id).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('createComplete')
            this.formReset()
            this.changeLoading = false
            this.createSubnetModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应'
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 表单重置
    formReset () {
      this.$refs.changeForm.resetFields()
    }
  }
}
</script>

<style scoped>
  .create-subnet-form {
    height: 650px;
    overflow-y: auto;
  }
  .create-subnet-form::-webkit-scrollbar {
    width: 5px;
  }
  .create-subnet-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .create-subnet-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
